//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Section.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"FeatureSpine",0,"Section",0],[1,"Spine",0,"Section",0],[0,"SpineOption",1,0],[0,"SpinePointList",0,"ObjectList",0]],[[["num_points","sp_points"],"GetSpinePoints",{},0,0],[["featureSpine"],"SetFeatureSpine",{},1,0],[[],"ResetSpine",{},0,0],[[],"CreateSpinePoint",{R_:{dimWithValueBuilder:"GeometricUtilities.OnPathDimWithValueBuilder"}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.AlongSpineBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.AlongSpineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.AlongSpineBuilder.RetainSpineOption = Object.freeze({
    "KeepOriginal" : "KeepOriginal", "Replace" : "Replace"});

export default SPLM;